import React from 'react'
import dummyFounder from '../../assets/images/dummyFounder.png'
import { formatActivityDuration } from '../../utils/formatActivityDuration'
const ActivityTab = ({ userActivity }) => {
    return (
        <div className='founder-activity'>
            <div className='founder-activity-section'>
                <div className='total-activities'>
                    <div className='total-hours'>
                        <div className="label">Total hours</div>
                        <div className="value">{formatActivityDuration(userActivity?.total)}</div>
                    </div>
                    <div className='average'>
                        <div className="label">Avg. per session</div>
                        <div className="value">{formatActivityDuration(userActivity?.average)}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ActivityTab